import { GridAlignment } from '@mui/x-data-grid';

import { CloudColumn } from './cloudColumn';
import { TagsColumn } from './tagsColumn';
import { AssetInventoryGridColDef } from '../../../types';
import { getDefaultColumnMaxWidth, getDefaultColumnMinWidth } from '../../../utils/table';

function accountGetter(val: string, row: Record<string, any>) {
  return row['_cq_account_name'] || row['account_name'] || val;
}

export const CloudAssetColumns: AssetInventoryGridColDef[] = [
  {
    field: 'cloud',
    headerAlign: 'center' as GridAlignment,
    headerName: 'CLOUD',
    maxWidth: getDefaultColumnMaxWidth(100),
    minWidth: getDefaultColumnMinWidth('Type', 100),
    renderCell: CloudColumn,
  },
  {
    field: 'resource_type_label',
    headerName: 'RESOURCE TYPE LABEL',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Type'),
  },
  {
    field: 'account',
    headerName: 'ACCOUNT NAME',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Account'),
    valueGetter: accountGetter,
  },
  {
    field: 'name',
    headerName: 'NAME',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Name'),
  },
  {
    field: 'region',
    headerName: 'REGION',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Region'),
  },
  {
    field: 'tags',
    headerName: 'TAGS',
    minWidth: 200,
    renderCell: TagsColumn,
  },
];

export const CloudAssetSharedColumns: AssetInventoryGridColDef[] = [
  {
    field: '_cq_cloud',
    headerAlign: 'center' as GridAlignment,
    headerName: 'CLOUD',
    maxWidth: getDefaultColumnMaxWidth(100),
    minWidth: getDefaultColumnMinWidth('Type', 100),
    renderCell: CloudColumn,
  },
  {
    field: '_cq_account',
    headerName: 'ACCOUNT NAME',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Account'),
    valueGetter: accountGetter,
  },
  {
    field: '_cq_name',
    headerName: 'NAME',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Name'),
  },
  {
    field: '_cq_region',
    headerName: 'REGION',
    maxWidth: getDefaultColumnMaxWidth(),
    minWidth: getDefaultColumnMinWidth('Region'),
  },
  {
    field: 'tags',
    headerName: 'TAGS',
    minWidth: 200,
    renderCell: TagsColumn,
  },
];
